import { IM365AppDefinition } from '@office-start/app-host-types';
import { CapabilitiesConfig } from '../shared/shared-context/capabilities.service';

const platformTestAppManifest: IM365AppDefinition = {
  version: '1.0.0',
  accentColor: '#d83b01',
  developerName: 'Microsoft Taos Experiences Team',
  devicePermissions: ['geolocation', 'media', 'midi', 'notifications', 'openExternal'],
  id: '07b75f22-72b5-4063-b7fc-0ed5ea8ff3ff',
  largeImageUrl:
    'https://static2.sharepointonline.com/files/fabric-cdn-prod_20200430.002/assets/brand-icons/product/png/office_48x2.png',
  name: 'Office MetaOS Test App',
  showLoadingIndicator: true,
  smallImageUrl:
    'https://static2.sharepointonline.com/files/fabric-cdn-prod_20200430.002/assets/brand-icons/product/png/office_48x1.png',
  staticTabs: [
    {
      contentUrl: 'https://jaguarshark.azurewebsites.net/',
      entityId: 'Milestones',
      name: 'Progress',
      scopes: ['personal'],
      websiteUrl: 'https://jaguarshark.azurewebsites.net'
    },
    {
      contentUrl: 'https://jaguarshark.azurewebsites.net/Contributors',
      entityId: 'Contributors',
      name: 'Contributors',
      scopes: ['personal'],
      websiteUrl: 'https://jaguarshark.azurewebsites.net'
    }
  ],
  termsOfUseUrl: 'https://jaguarshark.azurewebsites.net/',
  validDomains: [
    '*.bing.com',
    '*tab.azurewebsites.net',
    'statics.teams.cdn.office.net',
    'jaguarshark.azurewebsites.net'
  ],
  webApplicationInfo: {
    id: '07b75f22-72b5-4063-b7fc-0ed5ea8ff3ff',
    resource: 'https://jaguarshark.azurewebsites.net'
  }
};

const parkAppManifest: IM365AppDefinition = {
  version: '1.0.0',
  id: '7d396860-5e71-4ff0-bf71-8cd8bb119374',
  developerName: 'Microsoft',
  termsOfUseUrl: 'https://www.microsoft.com/en-us/servicesagreement',
  name: 'Park',
  smallImageUrl: 'https://officehome.cdn.office.net/officestartbundles/park-bundle-icon-48-blue-background.png',
  largeImageUrl: 'https://officehome.cdn.office.net/officestartbundles/park-bundle-icon-96-blue-background.png',
  shortDescription: 'Prototype for the Park Application',
  accentColor: '#d83b01',
  staticTabs: [
    {
      entityId: 'parkedItems',
      name: 'Parked items',
      websiteUrl: 'https://www.office.com/park',
      contentUrl: 'https://www.office.com/park',
      scopes: ['personal']
    },
    {
      entityId: 'suggestedItems',
      name: 'Suggested items',
      websiteUrl: 'https://www.office.com/park/parkingApp',
      contentUrl: 'https://www.office.com/park/parkingApp',
      scopes: ['personal']
    }
  ],
  validDomains: ['*.office.com'],
  showLoadingIndicator: false
};

const todoAppManifest: IM365AppDefinition = {
    version: '1.0.0',
    id: '7d30d5c91ee-5be2-4b79-81ed-23e6c4580427',
    developerName: 'Microsoft',
    termsOfUseUrl: 'https://www.microsoft.com/en-us/servicesagreement',
    name: 'To-Do',
    smallImageUrl: 'https://ow2.res.office365.com/todo/362889_2.44/favicon.ico',
    largeImageUrl: 'https://ow2.res.office365.com/todo/358299_2.43.2/icons/logo.png',
    shortDescription: 'To Do gives you focus, from work to play.',
    accentColor: '#d83b01',
    staticTabs: [
     {
        entityId: 'ToDoId',
        name: 'To-Do',
        websiteUrl: 'https://outlook-sdf.office.com/tasks?app&branch=anvm-metaos-auth-integ',
        contentUrl: 'https://outlook-sdf.office.com/tasks?app&hostApp=metaOSHub',
        scopes: ['personal']
     }
    ],
    validDomains: [
        'nightly.to-do.officeppe.com',
        '*.to-do.officeppe.com',
        '*.microsoftonline.com',
        '*.live.com',
        'to-do.office.com',
        '*.office.com',
        '*.microsoft.com'
    ],
    webApplicationInfo: {
        'id': '0d5c91ee-5be2-4b79-81ed-23e6c4580427',
        'resource': 'https://outlook-sdf.office.com'
    },
    showLoadingIndicator: false
};

const storeManifest: IM365AppDefinition = {
    version: '1.0.0',
    id: 'store',
    developerName: 'Microsoft',
    termsOfUseUrl: 'https://www.microsoft.com/en-us/servicesagreement',
    name: 'Store',
    devicePermissions: [
        'geolocation',
        'media',
        'midi',
        'notifications',
        'openExternal'
    ],
    largeImageUrl:
        'https://raw.githubusercontent.com/fayazara/fluenticons/master/static/regular_icons/app_folder.svg',
    smallImageUrl:
        'https://raw.githubusercontent.com/fayazara/fluenticons/master/static/regular_icons/app_folder.svg',
    shortDescription:
        'Get more done with apps! Add your favorite apps and find new ways to work smarter together.',
    accentColor: '#A80000',
    staticTabs: [
        {
            contentUrl:
                'https://teams.microsoft.com/extensibility-apps/store/view?language={locale}&host=metaos&metaoshost=office',
            entityId: '1',
            name: 'Store',
            scopes: ['personal'],
            websiteUrl: 'https://teams.microsoft.com'
        }
    ],
    validDomains: ['teams.microsoft.com'],
    webApplicationInfo: {
        id: 'store',
        resource: 'https://teams.microsoft.com'
    },
    showLoadingIndicator: true,
    isFullScreen: true
};

export function getAppManifests(capabilitiesConfig: CapabilitiesConfig): Map<string, IM365AppDefinition> {
    const appManifests = new Map([
        ['test', platformTestAppManifest],
        ['park', parkAppManifest],
        ['todo', todoAppManifest]
    ]);

    if (capabilitiesConfig.storeAppEnabled) {
        appManifests.set('store', storeManifest);
    }

    return appManifests;
}
